import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { LayoutVerticalSliderBulletComponent } from './layout-vertical-slider-bullet/layout-vertical-slider-bullet.component';
import { LayoutVerticalSliderRenderComponent } from './layout-vertical-slider-render.component';


export const components = [
  LayoutVerticalSliderRenderComponent,
  LayoutVerticalSliderBulletComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: components
})
export class LayoutVerticalSliderRenderModule {}

export default components;
